import { gql } from '@apollo/client';

export const QUERY_FIND_NOTIFICATIONS = gql`
    query FindNotifications {
        findNotifications {
            id
            name
            recordType {
                id
                name
                displayName
            }
            event {
                id
                name
                displayName
                recordTypeId
            }
            condition {
                fieldId
                fieldName
                fieldType
                operator
                value
            }
            priority
            frequency
            channels
            enabled
            createdAt
            updatedAt
        }
    }
`;

export const QUERY_GET_NOTIFICATION_EVENTS = gql`
    query GetNotificationEvents($recordTypeId: String!) {
        getNotificationEvents(recordTypeId: $recordTypeId) {
            id
            name
            displayName
            recordTypeId
        }
    }
`;
